import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpEventType, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

export class RequestHeadersInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEventType.Response>> {
        if (!req.headers.has('Content-Type')) {
            req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
        }

        return next.handle(req);
    }
}

export const RequestHeadersProvider = { provide: HTTP_INTERCEPTORS, useClass: RequestHeadersInterceptor, multi: true };
